import axios from 'axios'

import ClientSDK from '../../App/ClientSDK'

import { IApiUser, IUser } from './IUser'
import Transformer from './Transformer'

export const fetchUsers = (): Promise<IUser[]> => {
  const url = 'hr/persons'

  return ClientSDK.instance()
    .get(url)
    .then((response: any) => {
      return response.data.list.map((user: IApiUser) =>
        Transformer.transform(user),
      )
    })
}

export const getUsersAnonymous = (establishmentId: number) => {
  return axios
    .get('/api/anonymous/persons?establishment-filter=true', {
      params: { establishment_id: establishmentId },
    })
    .then(response => {
      return response.data.map((user: IApiUser) => Transformer.transform(user))
    })
}

export const fetchUser = (userId: undefined | number): Promise<IUser> => {
  let url = 'person'
  if (typeof userId !== 'undefined') {
    url += 's/' + userId
  }

  return ClientSDK.instance()
    .get(url)
    .then((response: any) => {
      return Transformer.transform(response.data.data.attributes)
    })
}

export const updateTimeSchedules = (
  userId: number,
  timeSchedules: number,
): Promise<any> => {
  const url = 'persons/' + userId

  return ClientSDK.instance().post(url, { schema_weeks: timeSchedules })
}
